import styled from "@emotion/styled";
import { Text } from "@mantine/core";

interface WorkStatusBoxProps {
  children: React.ReactNode;
  backgroundColor?: string | undefined;
}

export const WorkStatusBox = ({ children, backgroundColor }: WorkStatusBoxProps) => {
  return (
    <Content style={{ backgroundColor: backgroundColor }}>
      <Text size="xl" align="center">
        {children}
      </Text>
    </Content>
  );
};

const Content = styled.div`
  background-color: white;
  align-items: center;
  display: flex;
  justify-content: center;
  border-radius: 4px;
  padding: 4px;
  margin-top: 0.5rem;
  width: 100%;
  height: 96%;
`;
